import OTDetails from "../../components/ot/OTDetails";

const OTNote = () => {
  return <OTDetails screenTitle="OT Note" />;
};

export default OTNote;
